import ClaimEzyMed from '@/assets/pdf/ms-MY/ezyMedical/Bm_ELIB_EzyMedical_ClaimGuide.pdf';
import BenefitEzMed from '@/assets/pdf/ms-MY/ezyMedical/Bm_ELIB_EzyMedical_Cont.pdf';
import DeclarationEzyMed from '@/assets/pdf/ms-MY/ezyMedical/Bm_ELIB_EzyMedical_Declaration.pdf';
import UncoveredEzMed from '@/assets/pdf/ms-MY/ezyMedical/Bm_ELIB_EzyMedical_Exclusion.pdf';
import Brochure from '@/assets/pdf/ms-MY/ezyMedical/Brochure Ezy-Medical BM.pdf';
import PDS from '@/assets/pdf/ms-MY/ezyMedical/EzyMedical_PDS(MV).pdf';
import FAQ from '@/assets/pdf/ms-MY/ezyMedical/FAQ_EzyMedical (MV).pdf';
import PolicyContract from '@/assets/pdf/ms-MY/ezyMedical/Policy Contract_EzyMedical (MV).pdf';
import PremiumTable from '@/assets/pdf/ms-MY/ezyMedical/Premium Table - EzyMedical (MV).pdf';
import ClaimIMed from '@/assets/pdf/ms-MY/iMedical/Bm_EFTB_iMedical_ClaimGuide.pdf';
import BenefitIMedic from '@/assets/pdf/ms-MY/iMedical/Bm_EFTB_iMedical_Cont.pdf';
import DeclarationIMed from '@/assets/pdf/ms-MY/iMedical/Bm_EFTB_iMedical_Declaration.pdf';
import UncoveredIMedic from '@/assets/pdf/ms-MY/iMedical/Bm_EFTB_iMedical_Exclusion.pdf';
import ContributionRates from '@/assets/pdf/ms-MY/iMedical/i-MedicalCard Elite_Annual Contribution Rates.pdf';
import Brochure_iMedical from '@/assets/pdf/ms-MY/iMedical/i-MedicalCard Elite_e-Flyer(MV).pdf';
import PDS_iMedical from '@/assets/pdf/ms-MY/iMedical/i-MedicalCard Elite_PDS.pdf';
import ShariahConcepts from '@/assets/pdf/ms-MY/iMedical/i-MedicalCard Elite_Shariah Concepts.pdf';
import TakafulCertificate from '@/assets/pdf/ms-MY/iMedical/Policy Contract_i-MedicalCard (MV).pdf';
import FAQ_iMedical from '@/assets/pdf/ms-MY/iMedical/FAQ_iMCE (MV).pdf';
import { Product } from '@/data/enums/product';

export default {
  downloadDocuments: 'Muat Turun Dokumen',
  campaignTnc: 'Terma dan Syarat Kempen',
  [Product.EzyMedical]: {
    Benefit: BenefitEzMed,
    Uncovered: UncoveredEzMed,
    Declaration: DeclarationEzyMed,
    ClaimGuide: ClaimEzyMed,
    documents: [
      {
        name: 'Brosur',
        file: Brochure,
      },
      {
        name: 'Soalan Lazim',
        file: FAQ,
      },
      {
        name: 'Helaian Pendedahan Produk (PDS)',
        file: PDS,
      },
      {
        name: 'Kontrak Polisi',
        file: PolicyContract,
      },
      {
        name: 'Jadual Kadar Premium Tahunan',
        file: PremiumTable,
      },
      // {
      //   name: 'Jadual Bayaran Balik Premium',
      //   file: PremiumRefundTable,
      // },
    ],
  },
  [Product.iMedicalCard]: {
    Benefit: BenefitIMedic,
    Uncovered: UncoveredIMedic,
    Declaration: DeclarationIMed,
    ClaimGuide: ClaimIMed,
    documents: [
      {
        name: 'Brosur',
        file: Brochure_iMedical,
      },
      {
        name: 'Helaian Pendedahan Produk (PDS)',
        file: PDS_iMedical,
      },
      {
        name: 'Sijil Takaful',
        file: TakafulCertificate,
      },
      {
        name: 'Soalan Lazim',
        file: FAQ_iMedical,
      },
      {
        name: 'Jadual Kadar Sumbangan Tahunan',
        file: ContributionRates,
      },
      // {
      //   name: 'Jadual Bayaran Balik Sumbangan',
      //   file: ContributionSchedule,
      // },
      {
        name: 'Konsep-konsep Syariah',
        file: ShariahConcepts,
      },
    ],
  },
  [Product.EasyHealth]: {},
};
